export const serverEn = {
  recoverNoUser: 'There are no user with this email',
  incorrectEmail: 'Incorrect email'
}

export const serverRu: typeof serverEn = {
  recoverNoUser: 'Пользователь с этим email не найден',
  incorrectEmail: 'Неверный формат email адреса'
}
